import { criarRepositorio } from './createRepository';

export const repositorioLocalEstoque = criarRepositorio('local_estoque');
export const repositorioUnidadeMedida = criarRepositorio('unidade_medida');
export const repositorioCategoriaEstoque = criarRepositorio('categoria_estoque');
export const repositorioSubcategoriaEstoque = criarRepositorio('subcategoria_estoque');
export const repositorioEstoqueItem = criarRepositorio('estoque_item');
export const repositorioMovimentacaoEstoque = criarRepositorio('movimentacao_estoque');
export const repositorioAcertoEstoque = criarRepositorio('acerto_estoque');
